module.exports = __webpack_public_path__ + "img/qr-code.25dc74d8.svg";